exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Checkbox{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px}.Checkbox.error{color:var(--text-negative)}.Checkbox.error a{color:var(--text-negative);text-decoration:underline}.Checkbox-box{-webkit-margin-end:4px;margin-inline-end:4px;margin-top:1px}.Checkbox input[type=checkbox]{height:18px;margin:0;width:18px}.Checkbox a{color:var(--action-primary);font-weight:500}", ""]);

// exports
